<template>
  <wrapper>
    <main class="main-content-wrapper">
      <card>
        <div class="row">
            <div class="col-lg-3">
                ID PO/PR
                <input
                    type="text"
                    name=""
                    class="form-control"
                    placeholder="ID PO/PR"
                    v-model="searchPoID"
                />
            </div>
            <div class="col-lg-3">
                Nama Supplier
                <input
                    type="text"
                    name=""
                    class="form-control"
                    placeholder="Nama Supplier"
                    v-model="searchSupplierName"
                />
            </div>
            <div class="col-lg-3">
                Tanggal Dibuat
                <input
                    type="date"
                    name="createdDate"
                    class="form-control"
                    placeholder="dd/mm/yyyy"
                    v-model="searchDateCreated"
                />
            </div>
            <div class="col-lg-3">
                Status
                <multiselect
                    v-model="searchStatus"
                    :options="statusOptions"
                    :allow-empty="false"
                    :select-label="'Type'"
                    :deselect-label="''"
                    placeholder="Pilih Status"
                ></multiselect>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-4">
        <div>
          <button
            class="btn btn-primary default-btn"
            @click="searchData()"
          >
            Cari
          </button>
        </div>
        <div>
          <button
            class="btn reset-btn default-btn ml-2"
            @click="resetSearch()"
          >
            Reset
          </button>
        </div>
        </div>
      </card>
      <br />
    
      <div class="table-container">
        <table class="po-table">
          <thead>
            <tr>
              <th style="max-width: 8px;"></th>
              <th>TIPE</th>
              <th>ID PO/PR</th>
              <th>STATUS</th>
              <th>NAMA SUPPLIER</th>
              <th>TANGGAL DIBUAT</th>
              <th>TOTAL</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in purchaseOrders">
              <tr>
                <td>

                  <button 
                    class="expand-btn" 
                    @click="toggleExpand(index)">
                      <img
                        src="~@/assets/icon/arrow-down.png"
                        style="width: 8px"
                        v-if="!item.expanded"
                      />
                      <img
                        src="~@/assets/icon/arrow-up.png"
                        style="width: 8px"
                        v-else
                      />
                  </button>
                  
                </td>         
                <td>
                  <span class="po-badge">PO</span>
                </td>
                <td class="item-po">
                  <span class="po-link" @click="showModalPoPr('modalDetailPo','PO', item)">{{ item.id }}</span>
                </td>
                <td>
                  <span class="status-badge item-po" :class="getStatusClass(item.status)">
                    {{ item.status }}
                  </span>
                </td>
                <td class="item-po">{{ item.supplier }}</td>
                <td class="item-po">{{ item.createdDate }}</td>
                <td class="item-po">Rp {{ formatNumber(item.total) }}</td>
                <td class="item-po">
                  <button class="btn-receipt" @click="toCreateReceiptPage(item)" v-if="item.status !== 'To Bill'" :disabled="!editPurchaseReceipt">
                    <i class="fas fa-plus"></i> Buat Receipt
                  </button>
                </td>
              </tr>
              <!-- Expanded PR rows -->
              <template v-if="item.expanded">
                <template v-if="item.ListPurchaseReceipt && item.ListPurchaseReceipt.length > 0">
                  <tr 
                    v-for="(pr, prIndex) in item.ListPurchaseReceipt" 
                    :key="'pr-' + index + '-' + prIndex"
                    class="pr-row"
                  >
                    <td></td>
                    <td><span class="pr-badge">PR</span></td>
                    <td class="item-po">
                       <span class="po-link" @click="showModalPoPr('modalDetailPo','PR', pr)">{{ pr.id }}</span>
                    </td>
                    <td></td>
                    <td></td>
                    <td class="item-po">{{ pr.createdDate }}</td>
                    <td class="item-po">Rp {{ formatNumber(pr.total) }}</td>
                    <td>
                      <button class="btn btn-outline-secondary btn-sm" @click="showModalPoPr('modalDownloadPoLabel','PR', pr)">
                        <i class="fas fa-download"></i> Download Label
                      </button>
                    </td>
                  </tr>
                </template>
                <tr v-else :key="'empty-' + index">
                  <td colspan="8" class="text-center text-muted py-3">
                    Belum ada purchase receipt
                  </td>
                </tr>
              </template>
    
            </template>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <div style="margin-right: 10px">
            <select
              class="form-control form-control-sm"
              v-model="itemPerPage"
              @change="toDataPerPage(itemPerPage)"
            >
              <option value="10">10</option>
              <option value="40">40</option>
              <option value="80">80</option>
            </select>
          </div>
          <div class="total-data align-self-center">
            Total Data {{ totalData }}
          </div>
        </div>
        <div>
          <div class="pagination p8 alignRight">
            <ul>
              <a
                class="is-active link"
                @click="toDataPage(parseInt(currentPage) - 1)"
                v-if="currentPage != 1"
              >
                <li>
                  {{ "<" }}
                </li>
              </a>
              <a class="page">
                <li>{{ currentPage }} of {{ totalPage }} page</li>
              </a>
              <a
                class="is-active link"
                @click="toDataPage(parseInt(currentPage) + 1)"
                v-if="currentPage != totalPage"
              >
                <li>{{ ">" }}</li>
              </a>
            </ul>
          </div>
        </div>
      </div>

      <!-- MODAL -->
      <ModalPoDetail :modalData = "selectedPoData" :showModal="showModalPoPr"/>
      <ModalDownloadLabel :modalData = "selectedPoData"/>
    </main>
    <!-- /#page-content-wrapper -->
  </wrapper>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import SideBar from "../SideBar";
import { Wrapper, Card } from "../Layout";
import ModalPoDetail from "./CustomComponent/ModalPoDetail.vue";
import ModalDownloadLabel from "./CustomComponent/ModalDownloadLabel.vue";

export default {
  name: "PurchaseReceiptPage",
  components: {
    SideBar,
    Multiselect,
    Wrapper,
    Card,
    ModalPoDetail,
    ModalDownloadLabel,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      purchaseOrders: [],
      statusOptions:['To Bill','To Receive and Bill', 'To Receive'],
      searchStatus: "",
      searchSupplierName: "",
      searchPoID: "",
      searchDateCreated:'',
      admin: "",
      adminId: "",

      permission: [],
      viewPurchaseReceipt: false,
      editPurchaseReceipt: false,
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingButtonProcess: false,
      loadingButtonNext: false,
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      loadingTable: true,
      itemPerPage: 10,
      selectedPoData : '',
      selectedPrData : '',
    };
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    showModalPoPr(name, type, data) {
      if(type !== 'Free') {
        if(type == 'PR' && data.prId) {
          this.getDataDetail(data.prid, type)
        } else {
          this.getDataDetail(data.id, type)
        }
      }

      $(`#${name}`).modal('show')
      // $(`#modalDetailPo`).modal('show')
    },
    closeModal(name) {
       $(`#${name}`).modal('hide')
    },
    toCreateReceiptPage(item) {
      this.$router.push({
        path: '/purchase/receipt/create',
        query: {
            poId : item.id,
            supplierName : item.supplier,
        }
      })
    },
    toggleExpand(index) {
      this.purchaseOrders[index].expanded = !this.purchaseOrders[index].expanded;
    },
    getStatusClass(status) {
      if (status === 'To Receive') return 'status-to-receive';
      if (status === 'To Receive and Bill') return 'status-to-bill-receive';
      if (status === 'To Bill') return 'status-to-bill';
      return '';
    },
    resetSearch() {
      this.searchSupplierName = "";
      this.searchPoID = "";
      this.searchDateCreated = "";
      this.searchStatus = null
      this.currentPage = 1;
      this.itemPerPage = 10;
      this.searchData();
    },
    searchData() {
      this.$router.push(
        {
          path:'/purchase/receipt', 
          query: {
            poId: this.searchPoID,
            supplierName: this.searchSupplierName,
            status: this.searchStatus,
            dateCreated : this.searchDateCreated,
            page: 1,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toDataPage(pagePost) {
      this.$router.push(
        {
          path:'/purchase/receipt', 
          query: {
             poId: this.searchPoID,
            supplierName: this.searchSupplierName,
            status: this.searchStatus,
            dateCreated : this.searchDateCreated,
            page: pagePost,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toDataPerPage() {
      this.$router.push(
        {
          path:'/purchase/receipt', 
          query: {
            poId: this.searchPoID,
            supplierName: this.searchSupplierName,
            status: this.searchStatus,
            dateCreated : this.searchDateCreated,
            page: 1,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
        if(this.permission[i] == '25.1') {
          this.viewPurchaseReceipt = true
        }
        if(this.permission[i] == '25.2') {
          this.editPurchaseReceipt = true
        }
      }
      if (this.viewPurchaseReceipt == false) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id) {
      this.$router.push("/product/detail/" + id);
    },
    getDataDetail(id, type) {
        this.$http.post(process.env.GET_PO_DETAIL, {
            id: id,
            docType: type,
        },
        {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
            if(response.data.status == 200) {
              this.selectedPoData = {...response.data.data, type}
              if(type == 'PR') {
                let totalRate = 0
                this.selectedPoData.items.forEach(item => {
                  totalRate += item.rate 
                })
                this.selectedPoData.total = totalRate
                this.selectedPoData = {...this.selectedPoData, prId : id}
              }
            } else {
              swal("Error", response.data.message, "error");
            }
        })
        .catch(err => {
            swal("Error", err.message, "error");
        })
    },
    async getData() {
      try {
        this.loadingTable = true;
        this.searchSupplierName = this.$route.query.supplierName;
        this.searchPoID = this.$route.query.poId
        this.searchDateCreated = this.$route.query.dateCreated
        this.searchStatus = this.$route.query.status;
        this.currentPage = parseInt(this.$route.query.page);
        this.itemPerPage = parseInt(this.$route.query.itemPerPage);
   
        const response = await this.$http.post(
          process.env.GET_PO_LIST,
          { 
            id:this.searchPoID,
            // status: this.searchStatus.status, // 0 : all , 1 : To Receive,2 :To Bill & Receive; 3 : To Bill
            status : this.searchStatus,
            supplier:this.searchSupplierName,
            createdDate: this.searchDateCreated,
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
      
        if (response.data.status == 400) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          // this.handleLogout();
        } else {
          if (this.currentPage > response.data.data.totalPage) {
            this.searchData(1);
          } else {
            this.purchaseOrders = response.data.data.data.map(item => ({
              ...item,
              expanded: false
            }));
            this.totalPage = response.data.data.totalPage;
            this.currentPage = response.data.data.currentPage;
            this.totalData = response.data.data.totalData;
            this.loadingTable = false;
          }
        }
      } catch (error) {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then((v) => {
          if (error.response.data.status == 401) {
            this.handleLogout();
          }
        });
      }
    },

    sendLog(x, y) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + " " + time;
      var admin = this.admin;
      var command = "add-logs";
      var productName =
        this.productNameChoose == null
          ? this.productNameChoose
          : this.productNameChoose.replace(this.spaceRegex, " ");
      if (y == "34") {
        var newShowing = this.showingChoose;
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName, newShowing],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  async created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
    await this.getData();
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slide-enter-active, .slide-leave-active { transition: all 0.25s ease; }
    .slide-enter, .slide-leave-to { opacity: 0; transform: translateY(-6px); }
.item-po {
  font-size: 14px;
  font-weight: 500;
}
.no-pr-message {
  padding: 10px 0;
  text-align: center;
  font-style: italic;
}

.pr-row {
  background: #F8F9FA;
  border-bottom: 1px solid #e8f0fe;
}

.pr-content {
  display: grid;
  grid-template-columns: 60px 150px 1fr 1fr 200px;
  align-items: center;
  gap: 15px;
}

.pr-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #247FEC;
  color: #FFFFFF;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
}

.pr-badge-container {
  display: flex;
  justify-content: center;
}

.pr-id a {
  font-weight: 500;
}

.pr-date,
.pr-total {
  color: #495057;
}

.pr-action {
  text-align: right;
}
  .table-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 1rem;
    border: solid 1px;
    padding : 1.8px
  }
        
  .po-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
  }

  .po-table thead th {
    background: #f8f9fa;
    color: #6c757d;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    padding: 12px 15px;
    border: none;
  }
        
  .po-table tbody tr {
    border-bottom: 1px solid #e9ecef;
    transition: background 0.2s;
  }
  .po-table tbody td {
            padding: 15px;
            vertical-align: middle;
            border: none;
            border-bottom: 1px solid #e9ecef; /* tambahkan ini */
        }
        
        .expand-btn {
            background: none;
            border: none;
            border-radius: 4px;
            width: 20px;
            height: 30px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .expand-btn:hover {
            background: #dee2e6;
        }

        .po-badge {
            background: #6c757d;
            color: white;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 11px;
            font-weight: 500;
        }
        
        .po-link {
            color: #007bff;
            text-decoration: none;
            font-weight: 500;
            cursor: pointer;
        }
        
        .po-link:hover {
            text-decoration: underline;
        }
        
        .status-badge {
          display: inline-block;
          padding: 0.25em 0.4em;
          font-size: 75%;
          font-weight: 700;
          line-height: 1;
          text-align: center;
          white-space: nowrap;
          vertical-align: baseline;
          border-radius: 0.25rem;
          transition: color 0.15s;
          margin-right: 2px;
        }
        
        .status-to-receive {
            background: #e3f2fd;
            color: #1976d2;
        }
        
        .status-to-bill-receive {
            background: #fff3e0;
            color: #f57c00;
        }
        
        .status-to-bill {
            background: #e8f5e9;
            color: #388e3c;
        }
        
        .btn-receipt {
            background: #007bff;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: background 0.2s;
        }
        
        .btn-receipt:hover {
            background: #0056b3;
        }
        
        .btn-receipt i {
            margin-right: 5px;
        }
        
        .expanded-content {
            background: #f8f9fa;
            padding: 20px;
            text-align: center;
            color: #6c757d;
        }
        
        .slide-enter-active, .slide-leave-active {
            transition: all 0.3s ease;
        }
        
        .slide-enter, .slide-leave-to {
            opacity: 0;
            transform: translateY(-10px);
        }
.text-main-color {
  color: #2E3646;
}

.default-btn {
  font-weight: 600;
  height: fit-content;
  font-size: .875rem;
  padding: .5rem .75rem;
  border-radius: .375rem;
}

.icon-btn {
  border-radius: 8px;
  padding: 4px;
  background: #ffffff;
  width: 34px;
}

.icon-btn-blue {
  border: 1px solid #247FEC66;
}

.icon-btn-orange {
  border: 1px solid #F2641966;
}

.icon-btn-red {
  border: 1px solid #FF344480;
}

.icon-btn-green {
  border: 1px solid #C8DFCA;
}

.reset-btn {
  border: 1px solid #D1D9E2;
  color: #2E3646;
}

.field-label {
  width: 160px;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797fb;
  color: #fff;
  border: 1px solid #2797fb;
}

.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}

.total-data {
  font-size: 14px;
  color: #343a40;
}

.right-dropdown {
  margin-left: 7px;
}

.main-content-wrapper {
  padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Purchase/PurchaseReceiptPage.vue